import { type TravellersSelection } from '@secretescapes/cauldron';

export interface SelectionState {
  offerId: string;
  travellersSelection: TravellersSelection;
}

export enum SelectionActionType {
  OfferIdChange = 'OfferIdChange',
  TravellersSelectionChange = 'TravellersSelectionChange',
}

export interface OfferIdChangeAction {
  type: SelectionActionType.OfferIdChange;
  payload: string;
}

export interface TravellersSelectionChangeAction {
  type: SelectionActionType.TravellersSelectionChange;
  payload: TravellersSelection;
}

export type SelectionAction = OfferIdChangeAction | TravellersSelectionChangeAction;
